import React from "react";
import { ImageCropperView } from "./view";
import { styles } from "./styles";

export class ImageCropperWeb extends React.Component {
  render() {
    return <ImageCropperView {...this.props} styles={styles} />;
  }
}
